// extracted by mini-css-extract-plugin
export var separator = "styles-module--separator--43c7d";